class BdlKitPromo extends HTMLElement {
  connectedCallback() {
    this.desktop = this.querySelector('[data-bdl-kit-desktop]');
    if (!this.desktop) return;

    this.scrubTargets = [
      ...this.desktop.querySelectorAll('.bdl-kit__can'),
      this.desktop.querySelector('.bdl-kit__copy'),
    ].filter(Boolean);

    this.desktop.classList.add('is-scroll-driven');
    this.durationSec = 2.2; // Default→load 1s + load→final 1.2s
    this.onScroll = () => this.#scheduleUpdate();
    this.raf = 0;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#setProgress(1);
      return;
    }

    this.#setProgress(0);
    this.#scheduleUpdate();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.raf) window.cancelAnimationFrame(this.raf);
  }

  #scheduleUpdate() {
    if (this.raf) return;
    this.raf = window.requestAnimationFrame(() => {
      this.raf = 0;
      this.#updateProgress();
    });
  }

  #updateProgress() {
    const rect = this.desktop.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    const start = vh * 0.92;
    const end = vh * 0.2;
    const raw = (start - rect.top) / (start - end);
    this.#setProgress(Math.min(1, Math.max(0, raw)));
  }

  #setProgress(progress) {
    this.desktop.style.setProperty('--bdl-kit-progress', progress.toFixed(4));
    this.desktop.classList.toggle('is-complete', progress >= 0.92);

    const delay = `${-progress * this.durationSec}s`;
    this.scrubTargets.forEach((el) => {
      el.style.animationDelay = delay;
    });
  }
}

if (!customElements.get('bdl-kit-promo')) {
  customElements.define('bdl-kit-promo', BdlKitPromo);
}
